import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FornecedorAppRoutingModule } from './fornecedor.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FornecedorAppRoutingModule
  ]
})
export class FornecedorAppModule { }
